import React from "react";
import classNames from "classnames";
import { makeStyles } from "@mui/styles";
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import styles from '../styles/staticPages.js';
import Parallax from "components/Parallax/Parallax";
import { useSelector } from "react-redux";

const dashboardRoutes = [];
const useStyles = makeStyles(styles);

export default function DeleteAccount(props) {
  const classes = useStyles();
  const settings = useSelector(state => state.settingsdata.settings);
  const appName = "ENMI Remolque";
  const companyName = (settings && settings.CompanyName) ? settings.CompanyName : "ENMI Remolque App Solutions";
  const supportEmail = (settings && settings.contact_email) ? settings.contact_email : "ecuestreelrincon@gmail.com";
  const privacyPolicyUrl = "https://transport-caballos.web.app/privacy-policy";
  const { ...rest } = props;

  return (
    <div style={{ margin: "-8px" }}>
      <Header
        color="transparent"
        routes={dashboardRoutes}
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "white"
        }}
        {...rest}
      />
      <Parallax small filter image={require("assets/img/header-back.jpg").default} />
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <br />
          <h2 style={{ position: "relative", marginTop: "30px", minHeight: "32px", color: "#383838", textDecoration: "none" }}>
            Eliminación de cuenta
          </h2>

          <p className={classes.description}>
            Esta página explica cómo los usuarios de <strong>{appName}</strong>, operado por <strong>{companyName}</strong>, pueden eliminar su cuenta y los datos asociados.
          </p>
          <p className={classes.description}>
            Para eliminar tu cuenta, abre la aplicación móvil, entra a tu perfil, selecciona <strong>Eliminar cuenta</strong> y confirma la solicitud.
          </p>
          <p className={classes.description}>
            Cuando confirmas la eliminación, se eliminan de nuestros sistemas los datos asociados a tu cuenta, incluyendo tu información de perfil y los registros relacionados con la cuenta.
          </p>
          <p className={classes.description}>
            Si no puedes acceder a la aplicación, puedes solicitar la eliminación escribiendo a{" "}
            <a href={`mailto:${supportEmail}`}>
              <strong>{supportEmail}</strong>
            </a>.
          </p>
          <p className={classes.description}>
            Para más detalles, revisa nuestra{" "}
            <a href={privacyPolicyUrl} target="_blank" rel="noopener noreferrer">
              <strong>Política de privacidad</strong>
            </a>.
          </p>
          <br />
          <br />
        </div>
      </div>
      <Footer />
    </div>
  );
}
